import { newCOLORS } from '../../../../styles/colors';
import { redBase, secondaryBase } from '../../../../styles/design-tokens';

/**
 * Formats a token count as a compact string with K/M/B/T suffix.
 * "K" for thousands (no decimal); "M", "B", "T" for millions / billions /
 * trillions (1 decimal each). Values under 1,000 render as-is.
 *
 * @param {number} count - The token count
 * @returns {string} The compacted, suffixed string
 */
const formatTokenCount = (count: number): string => {
  if (count >= 1_000_000_000_000) {
    return `${(count / 1_000_000_000_000).toFixed(1)}T`;
  }
  if (count >= 1_000_000_000) {
    const value = count / 1_000_000_000;
    // toFixed(1) of values >= 999.95 rounds up to "1000.0" — promote to T.
    return value >= 999.95 ? `${(count / 1_000_000_000_000).toFixed(1)}T` : `${value.toFixed(1)}B`;
  }
  if (count >= 1_000_000) {
    const value = count / 1_000_000;
    return value >= 999.95 ? `${(count / 1_000_000_000).toFixed(1)}B` : `${value.toFixed(1)}M`;
  }
  if (count >= 1_000) {
    return `${Math.floor(count / 1_000)}K`;
  }
  return count.toString();
};

/**
 * Get the color for a progress percentage
 *
 * @param {number} percentage - The progress percentage
 * @returns {string} The color
 */
const getProgressColor = (percentage: number): string => {
  if (percentage >= 90) return redBase;
  if (percentage >= 70) return newCOLORS.orange;
  return secondaryBase;
};

export { formatTokenCount, getProgressColor };
